import { connect } from 'react-redux';
import Upcoming from 'components/Upcoming/Upcoming';
import { SCHEDULE_MODAL } from 'constants/ScheduleModal';
import { CALENDAR_DAYS } from 'constants/Calendar';
import { openFullScreenModal } from 'actions/FullScreenModal';
import _get from 'lodash/get';
import calendarSelectors from 'selectors/calendar';

const mapDispatchToProps = (dispatch) => ({
  openScheduleModal: () => {
    dispatch(openFullScreenModal(SCHEDULE_MODAL));
  }
});

const mapStateToProps = (state) => ({
  days: new Array(CALENDAR_DAYS),
  hasSelectedEvent: !!calendarSelectors.selectedMeetingIdSelector(state),
  isRefreshing: calendarSelectors.isRefreshingCalendars(state),
  noSyncedCalendars:
    !_get(state, 'app.calendar.outlook.calendarSignedIn') && !_get(state, 'app.calendar.google.calendarSignedIn')
});

export default connect(mapStateToProps, mapDispatchToProps)(Upcoming);
